import { CoreState, Session } from "@core/models";
import { selectCoreState } from "@core/store/reducers";
import { SWISSCOM_HEALTH_ORG_ADMIN_WRITE } from "@core/util";
import { createSelector } from "@ngrx/store";

export const selectSession = createSelector(
  selectCoreState,
  (state: CoreState) => state.session.session
);

// select that returns a boolean which indicates whether session has health org admin rights
export const selectIsSessionSwisscomHealthOrgAdminWrite = createSelector(
  selectSession,
  (session: Session): boolean => {
    return session.swisscomIamResources?.includes(SWISSCOM_HEALTH_ORG_ADMIN_WRITE) || false;
  }
);
